import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import GET_DEVICE_CLASSESS_LIST from '@shared/queries/getDeviceClassesQuery';

const useDeviceClassList = () => {
  const { data, loading, error } = useQuery(GET_DEVICE_CLASSESS_LIST);

  const deviceClassList = useMemo(() => {
    if (!data) {
      return [];
    }

    return data.deviceClasses.map(item => ({
      label: item.Value,
      value: item.Id,
      displayName: item.NumberDisplayName
    }));
  }, [data]);

  return { deviceClassList, deviceClassListLoading: loading, deviceClassListError: error };
};

export default useDeviceClassList;
